import axios from 'axios';
const timestamp = new Date().getTime();

let API_BASE_URL;
let NOVNC_URL;
let DCV_URL;
let SSH_WEB_PROXY;
let IS_PARATOOLS_DEMO = false;
let providersArr = [];
let brandingInfo = {};
let reg = true;
let timer = false;
let useWebsocket = false;
let updateTime = 5000;
let WEBSOCKET_SERVER;
let WEBSOCKET_PORT = 2222;
// Configuration will be loaded via loadConfig(); remove initial fetch to avoid race conditions

export const isTrainingEnabled = async () => {
	const result = await axios.get(`/assets/config.json?t=${timestamp}`);
	return result.data.training_enabled;
}

// Load config and return a promise that resolves when config is loaded
export const loadConfig = async () => {
	// At this point, API_BASE_URL is from env or set above; only dev fallback if on localhost and still empty
	// if (!API_BASE_URL && window.location.hostname === 'localhost') {
	// 	API_BASE_URL = 'http://localhost:12345';
	// 	console.log('loadConfig using dev fallback API_BASE_URL:', API_BASE_URL);
	// }

	return new Promise((resolve, reject) => {
		// Add cache-busting parameter to prevent stale config
		axios
			.get(`/assets/config.json?t=${timestamp}`)
			.then(res => {
				const { websocket_server, websocket_port, server, novnc_url, ssh_web_socket, providers, register, idleTimer, websocket, update_time, paratools_demo, training_login_route } = res.data;
				if (training_login_route) {
					brandingInfo = { ...brandingInfo, training_login_route };
				}
				if (server) {
					API_BASE_URL = server;
				} else if (!API_BASE_URL && window.location.hostname === 'localhost') {
				}
				if (websocket_server) {
					WEBSOCKET_SERVER = websocket_server;
				}
				if (websocket_port) {
					WEBSOCKET_PORT = websocket_port;
				}
				if (novnc_url) {
					NOVNC_URL = novnc_url;
				}
				if (res.data.dcv_url) {
					DCV_URL = res.data.dcv_url;
				} else if (API_BASE_URL) {
					// DCV proxy is integrated into the main API server
					DCV_URL = API_BASE_URL;
				}
				if (ssh_web_socket) {
					SSH_WEB_PROXY = ssh_web_socket;
				}
				if (providers) {
					providersArr = providers;
				}
				if (!register) {
					reg = false;
				}
				if (idleTimer) {
					timer = idleTimer;
				}
				if (websocket) {
					useWebsocket = websocket;
				}
				if (update_time) {
					updateTime = update_time;
				}
				if (paratools_demo) {
					IS_PARATOOLS_DEMO = paratools_demo;
				}
				resolve({
					API_BASE_URL,
					NOVNC_URL,
					DCV_URL,
					SSH_WEB_PROXY,
					IS_PARATOOLS_DEMO,
					providersArr,
					reg,
					timer,
					useWebsocket,
					updateTime,
					WEBSOCKET_SERVER,
					WEBSOCKET_PORT
				});
			})
			.catch(err => {
				console.error('Error loading config:', err);
				reject(err);
			});
	});
};

export {WEBSOCKET_SERVER, WEBSOCKET_PORT, API_BASE_URL, NOVNC_URL, DCV_URL, SSH_WEB_PROXY, IS_PARATOOLS_DEMO, providersArr, reg, timer, useWebsocket, updateTime, brandingInfo };
